import { ChangeDetectionStrategy, Component } from "@angular/core";
import { SettingsService, User } from "@delon/theme";
import {
  CertificateListService,
  NotificationService,
  StartupService,
} from "@core";

@Component({
    selector: "layout-sidebar",
    templateUrl: "./sidebar.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SidebarComponent {
  isVisiblePayment: boolean = false;

  get user(): User {
    return this.settings.user;
  }

  constructor(
    private startupService: StartupService,
    public notify: NotificationService,
    private settings: SettingsService,
    public accountBal: StartupService
  ) {}

  // rechargeModal(): void {
  // 	this.amount = 0;
  // 	this.units = 0;
  // 	this.isVisiblePayment = true;
  // }

  // handleModalCancel() {
  // 	this.isVisiblePayment = false;
  // }

  // convert(amount: any) {
  // 	this.units = amount / 20;
  // }

  // purchase() {
  // 	this.loading = true;
  // 	if (this.amount > 0 && this.units > 0) {
  // 		this.certificateService.userInfo.units =
  // 			Number(this.certificateService.userInfo.units) + Number(this.units);
  // 		this.certificateService.userInfo.amounts =
  // 			Number(this.certificateService.userInfo.amounts) + Number(this.amount);
  // 		this.certificateService.userInfo.initial_amount =
  // 			Number(this.certificateService.userInfo.amounts) + Number(this.amount);
  // 		this.notify.success('', 'Account Recharged Successfully!');
  // 		this.loading = false;
  // 		this.isVisiblePayment = false;
  // 	} else {
  // 		this.notify.info('', 'Invalid Amount!');
  // 		this.loading = false;
  // 	}
  // }
}
